class Resume {
  constructor(_id, id, name, videoURL, pdfURL,description, skills, category, transport, location, industry, isFavorite) {
    this._id = _id;
    this.id = id;
    this.name = name;
    this.videoURL = videoURL;
    this.pdfURL = pdfURL;
    this.description = description;
    this.skills = skills;
    this.category = category;
    this.transport = transport;
    this.location = location;
    this.industry = industry;
    this.isFavorite = isFavorite;
  }
}

module.exports = Resume;
